import { Link } from "react-router";
import "./brand-link.css";

type BrandLinkProps = {
  className?: string;
  to?: string;
  label?: string;
};

export function BrandLink({ className, to = "/", label = "MoodShow 首页" }: BrandLinkProps) {
  return (
    <Link className={["brand-link", className].filter(Boolean).join(" ")} to={to} aria-label={label}>
      <span className="brand-mark">
        <img src="/icon-192.png" alt="" width={32} height={32} />
      </span>
      <span className="brand-wordmark"><strong>MOOD</strong><em>SHOW</em></span>
    </Link>
  );
}
